import script from "./SkillsSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsSlider.vue?vue&type=script&setup=true&lang=js"

import "./SkillsSlider.vue?vue&type=style&index=0&id=535fe49b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535fe49b"]])

export default __exports__